import { createContext, useContext } from 'react';

import { ProgressContextProps } from '../../model/progressModel';

export const ResultsContext = createContext<ProgressContextProps>(null!);

const useResultsProgressContext = () => {
  return useContext<ProgressContextProps>(ResultsContext);
};

export default useResultsProgressContext;
